import { MapInvitation, UserWithAccessAndRole } from '../types';

interface AccessStatusProps {
  userOrInvitation: UserWithAccessAndRole | MapInvitation;
  resendingInvitation: string | null;
  onResendInvitation: (invitation: MapInvitation) => void;
}

export function AccessStatus({
  userOrInvitation,
  resendingInvitation,
  onResendInvitation,
}: AccessStatusProps) {
  // For users who have joined (have a joinedDate), show when they last visited
  if ('joinedDate' in userOrInvitation && userOrInvitation.joinedDate) {
    return (
      <p className="text-sm text-gray-500">
        {userOrInvitation.lastAccessedDate
          ? `Last seen: ${new Date(userOrInvitation.lastAccessedDate).toLocaleDateString()}`
          : 'Joined (no recent activity)'}
      </p>
    );
  }

  // For users who haven't joined yet (email invites or pending users), show "Pending" with resend option
  return (
    <div className="flex items-center">
      <span className="text-sm text-amber-600 font-medium">Pending</span>
      {/* Show resend button for both MapInvitation and UserWithAccessAndRole without joinedDate */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          // Cast to MapInvitation since onResendInvitation expects that type
          onResendInvitation(userOrInvitation as MapInvitation);
        }}
        disabled={
          resendingInvitation ===
          ('email' in userOrInvitation ? userOrInvitation.email : userOrInvitation.uid)
        }
        className="ml-2 text-xs text-blue-600 hover:text-blue-800"
      >
        {resendingInvitation ===
        ('email' in userOrInvitation ? userOrInvitation.email : userOrInvitation.uid) ? (
          <span className="flex items-center">
            <svg
              className="animate-spin -ml-1 mr-2 h-3 w-3 text-blue-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Resending...
          </span>
        ) : (
          'Resend invite'
        )}
      </button>
    </div>
  );
}
